import BasePageFilter           from '@/domains/BasePageFilter/BasePageFilter';
import type Store               from '@/domains/Stores/Store';
import type Partner             from '@/domains/Partners/Partner';
import type TransportZone       from "@/models/TransportZone/TransportZone";
import Assembly                 from "@/domains/Assemblies/Assembly";
import Shipment                 from "@/domains/Shipments/Shipment";
import TransportOrder from "@/domains/TransportOrders/TransportOrder";
import OrderPosition  from "@/domains/Orders/OrderPosition";
import Core           from "@/core/Core";
import Product                  from "@/domains/Products/Product";

class TransportableDocumentsFilter extends BasePageFilter {
    static Events = {
        Updated: 'transport-orders-page-filter:updated',
    } as const;

    static get DocumentClassOptions() {
        return [
            { id: 'Assembly', model: Assembly, name: Assembly.entityTypeName },
            { id: 'Shipment', model: Shipment, name: Shipment.entityTypeName },
            { id: 'TransportOrder', model: TransportOrder, name: TransportOrder.entityTypeName },
            { id: 'OrderPosition', model: OrderPosition, name: OrderPosition.entityTypeName },
            { id: 'Product', model: Product, name: Product.entityTypeName },
        ];
    }

    protected storageKey = 'filters:transport-orders';

    sender: Partner | undefined;

    sellerTransportZone: TransportZone[] = [];

    buyerStore: Store | undefined;

    private _documentClass: { id: string; name: string }[];

    set documentClass(value: (string | { id: string; name: string })[]) {
        if (!Array.isArray(value)) {
            value = [value];
        }

        this._documentClass = value.map(_item => {
            if (typeof _item === 'string') {
                return TransportableDocumentsFilter.DocumentClassOptions
                    .find(_option => _option.id === _item);
            } else {
                return _item;
            }
        }).filter(Boolean);
    }

    get documentClass(): { id: string; name: string }[] {
        return this._documentClass;
    }

    reset(): void {
        if (this.isLocked('buyerStore') === false) {
            this.buyerStore = undefined;
        }

        if (this.isLocked('documentClass') === false) {
            this.documentClass = [];
        }

        if (this.isLocked('sender') === false) {
            this.sender = undefined;
        }

        if (this.isLocked('sellerTransportZone') === false) {
            this.sellerTransportZone = [];
        }
    }

    protected deserialize(json: string): void {
        const parsed = JSON.parse(json);

        if (this.isLocked('buyerStore') === false) {
            this.buyerStore = parsed.buyerStore;
        }

        if (this.isLocked('sellerTransportZone') === false) {
            this.sellerTransportZone = Array.isArray(parsed.sellerTransportZone)
                ? parsed.sellerTransportZone
                : [];
        }

        if (this.isLocked('documentClass') === false) {
            this.documentClass = parsed.documentClass;
        }

        if (this.isLocked('sender') === false) {
            this.sender = parsed.sender;
        }
    }

    getRequestParams(): Record<string, any> {
        const params: any = {};

        if (this.buyerStore?.id) {
            params.buyerStore = { id: this.buyerStore.id };
        }

        if (Core.utils.isNotEmptyArray(this.documentClass)) {
            params.documentClass = this.documentClass.map(_item => _item.id);
        }

        if (this.sender?.id) {
            params.sender = { id: this.sender.id };
        }

        if (Core.utils.isNotEmptyArray(this.sellerTransportZone)) {
            params.sellerTransportZone = this.sellerTransportZone.map(_item => ({ id: _item.id }));
        }

        return params;
    }
}

export default TransportableDocumentsFilter;